import type { RefObject } from 'react';

import FunnelCard from 'containers/user/critical-elements-monitoring/components/funnel-card';
import type { FunnelDisplayMode } from 'containers/user/critical-elements-monitoring/components/funnel-stage-card';
import type { FunnelCardRowItem } from 'containers/user/critical-elements-monitoring/helpers/build-funnel-card-row';
import { getStageDataStatus } from 'containers/user/critical-elements-monitoring/helpers/get-stage-data-status';
import type { ProspectAvailability } from 'containers/user/critical-elements-monitoring/helpers/get-prospect-availability';
import type { CompareTo } from 'containers/user/critical-elements-monitoring/critical-elements-monitoring.types';
import { FUNNEL_PANEL_CLASSES } from 'containers/user/critical-elements-monitoring/monitoring-constants';

export interface FunnelExportLayoutProps {
  ref: RefObject<HTMLDivElement | null>;
  cardRow: FunnelCardRowItem[];
  enteringClass: number;
  compareTo: CompareTo;
  displayMode: FunnelDisplayMode;
  cohortLabel: string;
  prospectAvailability: ProspectAvailability;
}

const EXPORT_TILE_CLASSES = 'flex w-[240px] shrink-0';

const isExportableCard = (
  item: FunnelCardRowItem,
  displayMode: FunnelDisplayMode,
  prospectAvailability: ProspectAvailability
): boolean => {
  if (item.kind === 'extension-upsell') return false;

  const isInquiryWithoutData =
    item.kind === 'stage' &&
    item.stage.stageKey === 'inquiry' &&
    getStageDataStatus(item.stage, displayMode, prospectAvailability) !==
      undefined;

  return !isInquiryWithoutData;
};

const FunnelExportLayout = ({
  ref,
  cardRow,
  enteringClass,
  compareTo,
  displayMode,
  cohortLabel,
  prospectAvailability,
}: FunnelExportLayoutProps) => (
  <div
    aria-hidden="true"
    inert
    className="pointer-events-none fixed top-0 -left-[100000px]"
  >
    <div
      ref={ref}
      data-testid="total-funnel-export-layout"
      className="flex w-max flex-col gap-3 bg-white p-4"
    >
      <div>
        <h2 className="text-lg font-semibold text-gray-700">Total funnel</h2>
        <p className="text-xs text-gray-500">Entering class {enteringClass}</p>
      </div>

      <div className={FUNNEL_PANEL_CLASSES}>
        <div className="flex gap-3">
          {cardRow
            .filter((item) =>
              isExportableCard(item, displayMode, prospectAvailability)
            )
            .map((item) => (
              <div key={item.key} className={EXPORT_TILE_CLASSES}>
                <FunnelCard
                  item={item}
                  compareTo={compareTo}
                  displayMode={displayMode}
                  cohortLabel={cohortLabel}
                  prospectAvailability={prospectAvailability}
                />
              </div>
            ))}
        </div>
      </div>
    </div>
  </div>
);

export default FunnelExportLayout;
